import React from 'react'
import styled from '@emotion/styled'
import * as mixins from 'view/styles/mixins'
import * as constants from 'view/styles/constants'
import { AuthorisedUser } from 'api'
import { getUserInitials } from 'model'

interface AvatarProps {
  authorisedUser: AuthorisedUser
}

const AvatarStyled = styled.div`
  ${mixins.flexCenterContent};
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-color: ${constants.CORE_PRIMARY_2};
  background-size: cover;
  color: ${constants.CORE_PRIMARY_6};
`

export class Avatar extends React.Component<AvatarProps> {
  render() {
    const { authorisedUser } = this.props
    return <AvatarStyled>{getUserInitials(authorisedUser)}</AvatarStyled>
  }
}
